<template>
    <v-card variant="flat" style="height: 100%; width: 100%;overflow-y: auto; overflow-x: auto;" class="px-4 py-4">
      <v-row class="pa-2 customer">
        <v-col cols="1" class="py-0 d-flex align-center ga-5">
          <h2 class="clientname">Images</h2>
        </v-col>
        <v-col cols="3" class="py-0  d-flex align-center text-end">

            <input type="file" ref="fileInput" accept="image/*" style="display: none;" @change="handleFileSelect" />

            <v-btn @click.stop="triggerFileInput()" width="20" height="20" color="primary" icon rounded="circle">
              <v-icon size="18">mdi-plus</v-icon>
            </v-btn>
        </v-col>
        <v-col cols="12" >
          <v-container>
            <v-row>
              <v-col
                v-for="(item, index) in imageDetails"
                :key="index"
                cols="12" sm="6" md="4"
              >
                <v-hover v-slot="{ hover }">
                  <v-card class="image-card" elevation="6">
                    <div class="image-wrapper">
                      <v-icon class="eye-icon" @click="view(item)" :title="item.name">mdi-eye</v-icon>
                      <v-icon class="delete-icon" @click="deleteImage(index)" :title="item.name">mdi-delete-outline</v-icon>
                      <img
                        :src="item.src"
                        :class="[{ 'hover-zoom': hover }, 'image-menu']"
                        transition="fade-transition"
                      />
                    </div>
                    <!-- <v-card-title class="text-center">
                      Image {{ index + 1 }}
                    </v-card-title> -->
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
          </v-container>

          <v-dialog v-if="viewDialog" v-model="viewDialog" width="900">
            <v-card variant="flat" class="pa-0" style="border-radius: 16px;">
              <div style="display: flex; justify-content: flex-end;">
                <v-icon @click="viewDialog = false" class="cursor-pointer close">
                  mdi-close
                </v-icon>
              </div>
              <img :src="selectedImage.src" :alt="selectedImage.name" style="width: 100%; height: auto;" />
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      
    </v-card>
  </template>
  
  <script>

import clientDetailsService from '@/api/service/ClientDetails/ClientDetailsService';
import ClientDocumentsService from '@/api/service/ClientDocuments/ClientDocumentsService';
import moment from "moment";


  export default {
    components: {

    },
    data() {
      return {
         images: [
            "https://picsum.photos/600/350?random=1",
            "https://picsum.photos/600/350?random=2",
          ],
        viewType:null,
        index:null,
        id:null,
        viewDialog:false,
        selectedImage:null,
        currentIndex:null,
        organisationData:null,
        customerDialog:false,
        customerForm:[],
        customer:[],
        imageDetails:[],
        user_id:null,
      }
    },
    created() {
        this.getOrganisation();
        let user = localStorage.getItem('user_details')
        user = JSON.parse(user)
        this.user_id = user.id
        console.log(this.user_id,"this.user_id!!")
    },
    methods: {
        async getOrganisation() {
            let $id = this.$route.query.id
            this.organisationData = await clientDetailsService.findOne({ id: $id, collectionName: 'organisation' })
            this.imageDetails = this.organisationData && this.organisationData.imageDetails ? this.organisationData.imageDetails : this.imageDetails
            console.log(this.imageDetails,"this.imageDetails @@")
        },

        view(image) {
          console.log(image,"selectedImage")
          this.selectedImage = image;
          this.viewDialog = true;
        },
          triggerFileInput() {
            this.$refs.fileInput.click();
        },

        async handleFileSelect(event) {
          console.log(event,"event")
          const file = event.target.files[0];
          if (!file) return;

          const reader = new FileReader();

          reader.onload = async (e) => {
            let now = moment().format('YYYY-MM-DD HH:mm:ss')
            const imageBase64 = e.target.result;
            console.log(imageBase64,"imageBase64")
              let logoData = {
                  id: this.imageDetails.length + 1,
                  src: imageBase64,  
                  created: now,
                  modified: null,
                  created_by: this.user_id,  
                  modified_by: null,
                  active: 1,
                  deleted: 0,
                  deleted_by: null     
                }
                let $json = {
                    collectionName: 'documents',
                    name: file.name,
                    doc_name: file.name,
                    file_name: file.name,
                    key_type: "uploadFiles",
                    key_id: this.$route.query.id,
                    file_type: file.type,
                    active: 1,
                    src: imageBase64,
                    profile:true
                };
                const docData = await ClientDocumentsService.create($json)
                console.log("Base64 Image:", docData);
                logoData.docid = docData.data.data._id
                logoData.s3Url = docData.data.data.s3Url
                console.log("Base64 Image 1:", logoData);
                this.imageDetails.push(logoData)
            await this.save()
          };
          reader.readAsDataURL(file);
        },

          async deleteImage(index) {
            this.imageDetails.splice(index, 1);
            this.organisationData.imageDetails = this.imageDetails
            let $data = {
                collectionName: 'organisation',
                data: this.organisationData,
                id: this.$route.query.id
            }
            await clientDetailsService.update($data)
            console.log(this.organisationData,"processflow");
          },

        async save() {
            console.log("tttt!!!")
            this.organisationData.imageDetails = this.imageDetails
            console.log(this.organisationData,"this.organisationData")
            let $data = {
                collectionName: 'organisation',
                data: this.organisationData,
                id:this.$route.query.id
            }
            await clientDetailsService.update($data)
        },
    },
  };
  </script>
  
  <style scoped>
    .close{
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 1;
      cursor: pointer;
    }
    .eye-icon {
      z-index: 1;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
      font-size: 32px;
      color: rgba(0, 0, 0, 0.6);
      background: rgba(255, 255, 255, 0.7);
      border-radius: 50%;
      padding: 5px;
    }

    .delete-icon {
      position: absolute;
      top: 8%;
      right: 6%;
      transform: translate(50%, -50%);
      cursor: pointer;
      font-size: 20px;
      color: red;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 50%;
      padding: 8px;
    }
    .image-wrapper {
      height: 247px;
      overflow: hidden;
      border-radius: 5px;
    }

    .hover-zoom {
      transform: scale(1.1);
    }

    .image-menu{
      width: 100%;
      height: 247px;
      border-radius: 5px;
    }

    .image-wrapper img,
    .hover-zoom {
      transition: transform 0.4s ease;
    }

  </style>